// Components/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import userReducer from "./userSlice";

import favouritesReducer from "./favouritesSlice";
import cartItemsReducer from "./cartItemsSlice";
import locationsReducer from './locationsSlice'; // yeni
import commentsReducer from './commentsSlice'; // yeni

const rootReducer = combineReducers({
  favourites: favouritesReducer,
  cartItems: cartItemsReducer,
  locations: locationsReducer,
  comments: commentsReducer,
  user: userReducer
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
